import { Box } from '@mui/material';

import { RadioBoxButton } from '@/components';
import { CanProvinces } from '@/constants';
import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { ExtraBold } from './ExtraBold';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

export const CanCpaProvincesForm = () => {
  const dispatch = useAppDispatch();
  const stepInputs = useAppSelector(selectOnboardingStepInputs);

  const { value: provinces } = stepInputs[STEP_IDS.canCpaProvinces];

  const handleChange = (provinceCode: string) => {
    dispatch(
      onboardingActions.updateStepInputs({
        step: STEP_IDS.canCpaProvinces,
        input: { [provinceCode]: true },
      }),
    );
  };

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} Subtitle={<Subtitle />} />
      <Box sx={styles.formPrimarySection}>
        {Object.entries(CanProvinces).map(([key, name]) => (
          <Box key={key} sx={styles.checkboxContainer}>
            <RadioBoxButton
              label={name}
              checked={!!provinces[key]}
              onChange={() => handleChange(key)}
            />
          </Box>
        ))}
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => {
  return (
    <ModalTitle>
      As a <ExtraBold>CPA</ExtraBold> in <ExtraBold>Canada</ExtraBold>, select
      the province you&apos;re licensed in.
    </ModalTitle>
  );
};

const Subtitle = () => (
  <ModalSubtitle>
    This will help us determine what your reporting requirements are.
  </ModalSubtitle>
);
